import React from "react";

import { formatCurrency } from "../../helpers/formatters";
import { AgentData } from "../../hooks/use_agents_data";
import { useSortableTable } from "../../hooks/use_sortable_table";

interface AgentsLegendCardProps {
  agents: AgentData[];
}

export const AgentsLegendCard: React.FC<AgentsLegendCardProps> = ({
  agents,
}) => {
  const { sortedData, requestSort, getSortIndicator } = useSortableTable(
    agents,
    "name"
  );

  return (
    <div className="info-card">
      <h4 className="info-card-title">
        <span className="card-icon">🎨</span>
        Легенда агентів ({agents.length})
      </h4>

      <div className="agents-table-container">
        <table className="agents-table">
          <thead>
            <tr>
              <th
                className="sortable-header"
                onClick={() => requestSort("name")}
              >
                Назва агента
                {getSortIndicator("name")}
              </th>
              <th
                className="sortable-header"
                onClick={() => requestSort("seatCount")}
              >
                К-сть місць
                {getSortIndicator("seatCount")}
              </th>
              <th
                className="sortable-header"
                onClick={() => requestSort("revenue")}
              >
                Сума
                {getSortIndicator("revenue")}
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((agent) => (
              <tr key={agent.name}>
                <td>
                  <div className="agent-name-cell">
                    <span
                      className="agent-color-indicator"
                      style={{ backgroundColor: agent.color }}
                    ></span>
                    <span>{agent.name}</span>
                  </div>
                </td>
                <td className="text-center">{agent.seatCount}</td>
                <td className="text-right">{formatCurrency(agent.revenue)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
